import { InjectionToken } from '@angular/core';
import { TealiumConfig } from '@Shared/modules/tealium-utag.module';

export const TEALIUM_CONFIG_TOKEN = new InjectionToken<TealiumConfig>('TealiumConfig');
export const TEALIUM_PAGE_NAME_TOKEN = new InjectionToken<string>('TealiumPageName');
export const HASH_CRN_TOKEN = new InjectionToken<string>('hashCRN');
export const JOIN_NOW_TOKEN = new InjectionToken<string>('joinNow');
export const ENABLE_DEEP_LINKING_TOKEN = new InjectionToken<string>('enableDeepLinking');
